// ** React Imports
import { useState, useEffect } from 'react'


// ** Custom Components Imports
import _ from 'lodash'
import { ChatListItem } from '../../stores/NodeStore'
import useChats from '../../hooks/useChats'
import ChatDesigner from '../designer/ChatDesigner'
import FallbackSpinner from '../../../../materio/@core/components/spinner'


type Props = {
    chatId: string
}

const EditChatView = ({ chatId }: Props) => {
    const [editOpen, setEditOpen] = useState<boolean>(false)
    const { loadChat } = useChats();

    useEffect(() => {
        onRowClick({
            id: chatId
        } as ChatListItem)
    }, [])

    const onRowClick = async (row: ChatListItem) => {
        await loadChat(row.id);

        setEditOpen(true);
    };

    const onClose = () => {
        window.close();
    }

    if (!editOpen) return <FallbackSpinner />

    return <ChatDesigner chatId={chatId} key={chatId} onClose={onClose} open={editOpen} />
}

export { EditChatView }
export default EditChatView
